import { render, staticRenderFns } from "./LocationMove.vue?vue&type=template&id=6a45376a"
import script from "./LocationMove.vue?vue&type=script&lang=js"
export * from "./LocationMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports